const submit = (values: any) => {
  //   const {password, phone} = values;
  //   const bcrtyPwd = handleChangePassword(password).then((result) => {
  //     return result;
  //   });
  //   console.log(password, phone);
};

export default submit;
